import React from 'react'

import AvailableSlotsIndicator from '@/components/integration/nylas/scheduler/components/availability/AvailableSlotsIndicator'
import { useSchedulerConfig } from '@/components/integration/nylas/scheduler/context/SchedulerConfigContext'
import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'

interface Props {
  date: Date
  availableSlots: number
  animationIndex: number
  isSelected?: boolean
  onClick: () => void
  isLoading: boolean
}

const CustomPickerButton: React.FC<Props> = ({
  date,
  availableSlots,
  animationIndex,
  isSelected = false,
  onClick,
  isLoading,
}) => {
  const { timezone } = useSchedulerConfig()
  const isAvailable = availableSlots !== 0

  return (
    <Button
      type="button"
      variant={isSelected ? 'outline-primary' : 'outline'}
      className={cn(
        `pop-in bg-card flex h-full w-20 cursor-pointer flex-col items-center
        gap-0 rounded-2xl border py-3 text-center`,
        isAvailable
          ? 'text-dark'
          : 'cursor-not-allowed opacity-50 hover:bg-transparent',
        isSelected
          ? 'hover:bg-card text-primary hover:text-primary'
          : 'hover:bg-accent',
      )}
      onClick={() => {
        if (isLoading || !isAvailable) {
          return
        }

        onClick()
      }}
      style={{
        animationDelay: `${animationIndex * 64}ms`,
        animationFillMode: 'both',
      }}
    >
      <span className="mt-1">
        {date.toLocaleDateString('en-GB', {
          weekday: 'short',
          timeZone: timezone,
        })}
      </span>

      <span className="text-2xl font-bold">
        {date.toLocaleDateString('en-GB', {
          day: 'numeric',
          timeZone: timezone,
        })}
      </span>

      <AvailableSlotsIndicator
        count={availableSlots}
        size="md"
        isLoading={isLoading}
      />
    </Button>
  )
}

export default CustomPickerButton
